// App entry. Nothing here is sim-aware: under `vite --mode sim` the page loads
// src/sim/sim-main.ts instead (vite.config.ts), which installs the sim clock and
// only then imports this module — so the whole app evaluates on sim time.
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Login } from './Login';
import { MOCK } from './lib/mode';
import { onAuthChange } from './lib/firebase';
import { ws } from './lib/ws';
import { perf } from './lib/perf';
import '../styles.css';
import '../overlay.css';
import '../dock.css';
import '../vision.css';
import '../trendlines.css';
import '../borrow.css';
import '../supply.css';
import '../entrymarks.css';

// Auth gate: in MOCK mode, bypass auth and run the sim. In live mode, render Login
// until Firebase resolves a user, then connect the WS and render the Terminal.
function Root() {
  const [user, setUser] = React.useState<any>(MOCK ? { displayName: 'Demo Trader', email: 'demo@momentum.sim' } : null);
  const [ready, setReady] = React.useState<boolean>(MOCK);

  React.useEffect(() => {
    if (MOCK) return;
    const off = onAuthChange((u: any) => {
      setUser(u);
      setReady(true);
      if (u) ws.connect();
      else ws.disconnect();
    });
    return off;
  }, []);

  if (!ready) return null; // brief splash window while Firebase resolves the session
  if (!user) return React.createElement(Login);
  return React.createElement(App, { user });
}

perf.init(); // perf instrument — inert unless ?perf / Ctrl+Alt+P (see lib/perf.ts)

createRoot(document.getElementById('root')!).render(React.createElement(Root));
